import * as yup from 'yup';

export const schema = (messages: any) =>
  yup.object().shape({
    name: yup
      .string()
      .trim()
      .required(messages['countries.region.validate.name'].toString()),
    displayOrder: yup
      .number()
      .typeError(
        messages['countries.validate.displayOrder.typeError'].toString(),
      )
      .required(
        messages['countries.validate.displayOrder.required'].toString(),
      ),
  });
